import React from "react";
import _validator from 'modules/validator';
import MyInput from 'components/controls/MyInput';
import { GENERAL_ERROR_MESSAGE, PASSWORD_UPDATE_SUCCESS, APP_USER_ID } from 'constants/constants';
import _notification from 'modules/notification';
import _authService from 'modules/AuthService';

class ChangePassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            oldPassword: '',
            oldPasswordError: '',
            newPassword: "",
            newPasswordError: "",
            confirmPassword: "",
            confirmPasswordError: ""
        };
    }
    handleCancel = () => {
        this.setState({
            oldPassword: '',
            oldPasswordError: '',
            newPassword: "",
            newPasswordError: "",
            confirmPassword: "",
            confirmPasswordError: ""
        })
    };


    onTextChange = ({ target: { name, value } }) => {
        this.setState({ [name]: value.trim() });
    }

    handlePasswordChange = async (input) => {

        if (this.validateFormData()) {
            return
        }

        const app_id = localStorage[APP_USER_ID];
        const params = {
            OldPassword: this.state.oldPassword,
            NewPassword: this.state.newPassword,
            Application_Id: app_id,
        }
        try {
            const response = await _authService.changePassword(params);
            if (response.data.IsSuccess == true) {

                _notification.showMessage('success', PASSWORD_UPDATE_SUCCESS);

                this.setState({
                    oldPassword: '',
                    oldPasswordError: '',
                    newPassword: "",
                    newPasswordError: "",
                    confirmPassword: "",
                    confirmPasswordError: ""
                }, () => {
                    this.props.closeModal();
                });
            }
            else {
                _notification.showMessage('error', response.data.message);
            }
        } catch (e) {
            _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
        }
    }

    validateFormData = () => {
        let body = this.state;

        this.setState({
            oldPasswordError: '',
            newPasswordError: "",
            confirmPasswordError: ""
        });

        let hasError = false;

        if (!body.oldPassword) {
            this.setState({ oldPasswordError: 'Please enter old password' });
            hasError = true
        }

        if (!body.newPassword) {
            this.setState({ newPasswordError: 'Please enter new password' });
            hasError = true
        }

        if (!body.confirmPassword) {
            this.setState({ confirmPasswordError: 'Please enter confirm password' });
            hasError = true
        }

        if ((body.newPassword && body.confirmPassword) && (body.newPassword != body.confirmPassword)) {
            _notification.showMessage('error', 'New Password and Confirm Password not matched');
            this.setState({
                confirmPasswordError: "New Password and Confirm Password not matched",
                newPasswordError: "New Password and Confirm Password not matched"
            });
            hasError = true
        }

        return hasError;
    }

    render() {
        // let setNewState = this.props.objStateUpdate
        // this.setState({
        //     setNewState
        // })
        return (
            <div className="row">
                <div className="mb-2 col-sm-12  pb-3">
                    <h5 className="color-secondary">Change Password </h5>
                </div>
                <div className="mb-2 col-sm-12">
                    <label for="oldPassword">Old Password</label>
                    <MyInput id="oldPassword"
                        type="password"
                        //placeholder="********"
                        key="oldPassword"
                        name="oldPassword"
                        value={this.state.oldPassword}
                        onChange={this.onTextChange}
                        isRequired={true}
                        errorState={this.state.oldPasswordError}
                        errorMessage={this.state.oldPasswordError} />
                </div>
                <div className="mb-2 col-sm-6">
                    <label for="NewPassword">New Password</label>
                    <MyInput id="newPassword"
                        type="password"
                        //placeholder="********"
                        key="newPassword"
                        name="newPassword"
                        value={this.state.newPassword}
                        onChange={this.onTextChange}
                        isRequired={true}
                        errorState={this.state.newPasswordError}
                        errorMessage={this.state.newPasswordError}
                    />
                </div>
                <div className="mb-2 col-sm-6">
                    <label for="confirmPassword">Confirm Password</label>
                    <MyInput id="confirmPassword"
                        //id="confirmPassword"
                        type="password"
                        //placeholder="********"
                        key="confirmPassword"
                        name="confirmPassword"
                        value={this.state.confirmPassword}
                        onChange={this.onTextChange}
                        onBlur={this.onTextChange}
                        disabled={this.state.newPassword ? '' : true}
                        isRequired={true}
                        errorState={this.state.confirmPasswordError}
                        errorMessage={this.state.confirmPasswordError}
                    />
                </div>                
                <div className="mb-2 mt-3 col-sm-12">
                    <button type="button" onClick={this.handlePasswordChange} class="ant-btn ant-btn-primary"><span>Reset Password</span></button>
                </div>
            </div>
        );
    }
}

export default ChangePassword;